// ANDREA - ARCA METAFIELDS SWATCH SYNC

// === SYNC RADIO HEADER UTILITY ===
function syncRadioHeader(selectedInput, root) {
    const headerSpan = root.querySelector('.radios--header span');
    if (!headerSpan || !headerSpan.textContent) {
        return;
    }
    if (!selectedInput) {
        selectedInput = root.querySelector('.arca-swatch-input:checked, .radios--input:checked');
    }
    if (!selectedInput) {
        return;
    }
    const label = headerSpan.textContent.split(':')[0];
    const spanLabel = `${label}: ${selectedInput.value}`;

    if (root !== document) {
        document.querySelectorAll('drawer-element .radios--header').forEach((header) => {
            header.querySelector('span').textContent = spanLabel;
        });
    } else {
        root.querySelector('.radios--header span').textContent = spanLabel;
    }
}

// === SCHEDA PRODOTTO ===
function enableProductPageRadioSync() {
    // Listener su document
    document.addEventListener('change', function(event) {
        if (
            event.target.classList.contains('arca-swatch-input') ||
            event.target.classList.contains('radios--input')
        ) {
            // Evita di reagire se il target è dentro un drawer
            const drawer = document.querySelector('drawer-element.drawer--root');
            if (!drawer || !drawer.contains(event.target)) {
                syncRadioHeader(event.target, document);
            }
        }
    });

    // Sync iniziale
    syncRadioHeader(null, document);

    // Observer per rigenerazione varianti
    const productMain = document.querySelector('.product-wrapper');
    if (productMain) {
        const observer = new MutationObserver((mutations) => {
            syncRadioHeader(null, document);
        });
        observer.observe(productMain, { childList: true, subtree: true });
    }
}

// === LISTATO / QUICKVIEW DRAWER ===
function enableDrawerRadioSync() {
    let drawer = document.querySelector('drawer-element.drawer--root');
    if (!drawer) {
        return;
    }

    // Listener solo nel drawer
    drawer.addEventListener('change', function(event) {
        if (
            event.target.classList.contains('arca-swatch-input') ||
            event.target.classList.contains('radios--input')
        ) {
            syncRadioHeader(event.target, drawer);
        }
    });

    // Sync drawer al click su quickview
    const quickviewButtons = document.querySelectorAll('.product-quick-add--button');
    quickviewButtons.forEach(button => {
        button.addEventListener('click', function() {
            let drawer = document.querySelector('drawer-element');
            if (!drawer) {
                return;
            }
            let product_quick_add_form = drawer.querySelectorAll('.product-quick-add--form');
            // Verifico quali di questi form sono visibili in pagina
            product_quick_add_form.forEach(form => {
                // Verifico se il form è visibile dall'attributo aria-hidden
                if (form.getAttribute('aria-hidden') === 'true') {
                    return;
                }
                // Faccio checked sul primo input arca-swatch-input
                const firstInput = form.querySelector('.arca-swatch-input');
                if (firstInput) {
                    firstInput.checked = true;
                    syncRadioHeader(firstInput, drawer);
                }
            });
        });
    });

    return true;
}

// === MAIN LOGIC ===
document.addEventListener('DOMContentLoaded', function() {
    // Decide se siamo in pagina prodotto o listato
    const isProductPage = document.querySelector('.main-product--wrapper');
    const isCollectionPage = document.querySelector('.main-collection--wrapper');
    if (isProductPage) {
        enableProductPageRadioSync();
    }
    if (isCollectionPage) {
        enableDrawerRadioSync();
    }
});